module.exports = __webpack_public_path__ + "img/gzh.2705d25b.jpg";